import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "worker-item-header" };
const _hoisted_2 = { class: "worker-list-outer" };
const _hoisted_3 = { class: "related-worker-outer" };
const _hoisted_4 = { class: "related-worker-list" };
const _hoisted_5 = { class: "related-worker-list-empty" };
const _hoisted_6 = {
    ref: "workerListOuter",
    class: "worker-list",
    "data-cy": "worker-list"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_WorkerItem = _resolveComponent("WorkerItem");
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("span", {
                class: _normalizeClass(["cy-worker-header-name name", _ctx.workerSortByClass('workerName')]),
                "data-sort-by": "workerName",
                onClick: _cache[0] || (_cache[0] =
                    //@ts-ignore
                    (...args) => (_ctx.handleClickWorkerSortBy && _ctx.handleClickWorkerSortBy(...args)))
            }, _toDisplayString(_ctx.$t(_ctx.lc + 'name')), 3 /* TEXT, CLASS */),
            _createElementVNode("span", {
                class: _normalizeClass(_ctx.workerSortByClass)
            }, _toDisplayString(_ctx.$t(_ctx.lc + 'status')), 3 /* TEXT, CLASS */),
            _createElementVNode("span", {
                "data-sort-by": "allocated",
                class: _normalizeClass(_ctx.workerSortByClass('allocated')),
                onClick: _cache[1] || (_cache[1] =
                    //@ts-ignore
                    (...args) => (_ctx.handleClickWorkerSortBy && _ctx.handleClickWorkerSortBy(...args)))
            }, _toDisplayString(_ctx.$t(_ctx.lc + 'allocated')), 3 /* TEXT, CLASS */),
            _createElementVNode("span", {
                "data-sort-by": "pickup",
                class: _normalizeClass(_ctx.workerSortByClass('pickup')),
                onClick: _cache[2] || (_cache[2] =
                    //@ts-ignore
                    (...args) => (_ctx.handleClickWorkerSortBy && _ctx.handleClickWorkerSortBy(...args)))
            }, _toDisplayString(_ctx.$t(_ctx.lc + 'pickup')), 3 /* TEXT, CLASS */),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t(_ctx.lc + 'gps')), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_2, [
            _createCommentVNode(" 연관 영역: 선택한 주문의 배차 라이더 영역 "),
            _withDirectives(_createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "related-worker-list-title" }, " 선택한 주문을 배차한 라이더 ", -1 /* CACHED */)),
                    (_ctx.isRelatedWorkerListExist)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.relatedWorkerList, (worker, key) => {
                            return (_openBlock(), _createBlock(_component_WorkerItem, {
                                key: key,
                                "is-selected": _ctx.isSelected(worker.code),
                                "on-click-worker-item": _ctx.onClickWorkerItem,
                                "worker-data": worker,
                                "is-related-worker": ""
                            }, null, 8 /* PROPS */, ["is-selected", "on-click-worker-item", "worker-data"]));
                        }), 128 /* KEYED_FRAGMENT */))
                        : _createCommentVNode("v-if", true),
                    _withDirectives(_createElementVNode("div", _hoisted_5, " - ", 512 /* NEED_PATCH */), [
                        [_vShow, !_ctx.isRelatedWorkerListExist]
                    ])
                ])
            ], 512 /* NEED_PATCH */), [
                [_vShow, _ctx.getterHasDeliveringOrder]
            ]),
            _createElementVNode("div", _hoisted_6, [
                _withDirectives(_createElementVNode("div", { class: "pt-5 text-center" }, _toDisplayString(_ctx.resultText), 513 /* TEXT, NEED_PATCH */), [
                    [_vShow, _ctx.isEmpty]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainWorkerList, (worker, key) => {
                    return (_openBlock(), _createBlock(_component_WorkerItem, {
                        class: "cy-worker-item",
                        "data-cy": "worker-item",
                        key: key,
                        ref_for: true,
                        ref: worker.user.code,
                        "is-selected": _ctx.isSelected(worker.code),
                        "on-click-worker-item": _ctx.onClickWorkerItem,
                        "worker-data": worker
                    }, null, 8 /* PROPS */, ["is-selected", "on-click-worker-item", "worker-data"]));
                }), 128 /* KEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */)
        ])
    ]));
}
